export default "__VITE_ASSET__b8c0e790__"